import AppIcon from '../../../components/AppIcon';
import { formatNumber } from '../../../utils/formatNumber';

const CurrentActivityPanel = ({ activity }) => {
  const activityItems = [
    {
      icon: 'Calendar',
      label: 'حجوزات نشطة',
      value: formatNumber(activity?.activeBookings || 0),
      color: 'var(--color-primary)',
      description: 'حجوزات قيد الانتظار أو المؤكدة'
    },
    {
      icon: 'Clock',
      label: 'مدفوعات معلقة',
      value: formatNumber(activity?.pendingPayments || 0),
      color: 'var(--color-warning)',
      description: 'مدفوعات في انتظار المعالجة'
    },
    {
      icon: 'UserCheck',
      label: 'مصورون متاحون',
      value: formatNumber(activity?.availablePhotographers || 0),
      color: 'var(--color-success)',
      description: 'مصورون جاهزون لقبول الحجوزات'
    }
  ];

  return (
    <div className="bg-gradient-to-br from-primary/5 to-accent/5 rounded-xl p-4 md:p-6 border border-primary/10 mb-6 md:mb-8">
      <div className="flex items-center gap-2 mb-4">
        <AppIcon name="Activity" size={24} color="var(--color-primary)" />
        <h3 className="text-lg md:text-xl font-bold text-foreground">
          النشاط الحالي على المنصة
        </h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {activityItems?.map((item, index) => (
          <div
            key={index}
            className="bg-card rounded-lg p-4 shadow-warm hover:shadow-warm-md transition-smooth"
          >
            <div className="flex items-start gap-3">
              <div
                className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0"
                style={{ backgroundColor: `${item?.color}15` }}
              >
                <AppIcon name={item?.icon} size={24} color={item?.color} />
              </div>
              <div className="flex-1">
                <p className="text-sm text-muted-foreground mb-1">{item?.label}</p>
                <p className="text-2xl md:text-3xl font-bold text-foreground mb-1">
                  {item?.value}
                </p>
                <p className="text-xs text-muted-foreground">{item?.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CurrentActivityPanel;